import { useContext } from 'react';

import { decodeSiteResolutionFunc, SiteResolutionContext } from 'shared/mechanics/site-resolution';

import { AuthSignInImage } from './components/Image';
import { AuthSignInButtons } from './components/Buttons';

export const AuthSignInLayout = () => {
	const siteResolution = useContext(SiteResolutionContext);

	var layoutComponent = decodeSiteResolutionFunc(siteResolution, () => <AuthSignInLayoutDesktop />, () => <AuthSignInLayoutCompact />);
	return layoutComponent;
};

const AuthSignInLayoutDesktop = () => {
	return (
		<div className={`flex-container-horizontal flex-size-fill`}>
			<AuthSignInImage className="flex-size-same" />
			<AuthSignInButtons className="flex-size-same"/>
		</div>
	);
};
const AuthSignInLayoutCompact = () => {
	return (
		<div className={`flex-container-horizontal flex-size-fill`}>
			<AuthSignInButtons className="flex-size-same"/>
		</div>
	);
};